import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';
import eachElement from 'Utils/eachElement.js';
import analytics from 'Scripts/analytics.js';
import calendly from 'Scripts/calendly.js';

import { chartConfig } from './charts.js';

document.addEventListener('DOMContentLoaded', () => {
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.toggle('is-loaded');

		/* Lifecycle */
		const lifecycle = document.querySelector('.section.is-lifecycle');
		if (lifecycle) {
			const lifecycleStage = lifecycle.querySelector('svg');
			eachElement('.section.is-lifecycle li button', item => {
				/* Get values */
				const values = JSON.parse(item.dataset.values);

				/* Display legend */

				/* Create ul */
				const legend = document.createElement('ul');
				for (const key of Object.keys(values)) {
					const li = document.createElement('li');
					li.className = key;
					legend.append(li);
				}

				item.prepend(legend);

				/* Highlight items */
				item.addEventListener('mouseover', () => {
					setTimeout(() => {
						for (const key of Object.keys(values)) {
							/* Activate label */
							const label = lifecycleStage.querySelector(`#label-${key}`);
							label?.classList.add('is-active');
							/* Display area fill */
							const area = lifecycleStage.querySelector(`#area-${key}`);
							area?.setAttribute('opacity', '1');
						}
					}, 1);
				});

				/* Remove highlight */
				item.addEventListener('mouseout', () => {
					const labels = lifecycleStage.querySelectorAll('.label');
					for (const path of labels) {
						path.classList.remove('is-active');
					}

					const areas = lifecycleStage.querySelectorAll('.area');
					for (const path of areas) {
						path.setAttribute('opacity', '0');
					}
				});
			});
		}
	});

	analytics.trackTaggedAnchors();
	calendly.setUpCalendly();

	/* Update ROI chart when slider is changed */
	document.querySelector('#roi-team-size')?.addEventListener('change', function () {
		const chartContainer = this.closest('.chart.is-roi');
		const canvas = chartContainer.querySelector('canvas');
		const chart = chartContainer.chartInstance;

		const newData = chartConfig.data.roi(chart.data, JSON.parse(canvas.dataset.data), chartContainer);
		chart.data.datasets[0].data = newData.datasets[0].data;
		chart.data.labels = newData.labels;

		// Trigger the chart update
		chart.update();
	});

	/* Smooth scrolling for table of contents */
	eachElement('.menu-list a', element => {
		element.addEventListener('click', function (event) {
			event.preventDefault();

			/* Hide mobile menu */
			document.documentElement.classList.remove('has-contents-active');

			/* Scroll to destination */
			document.querySelector(this.getAttribute('href'))?.scrollIntoView({
				behavior: 'smooth',
			});

			/* Update hash in URL */
			history.pushState(null, null, this.getAttribute('href'));
		});
	});

	/* Scroll the hero button to the first available section
	   (the foreword, or the gate form when the report is gated) */
	document.querySelector('.hero a[href="#foreword"]')?.addEventListener('click', event => {
		event.preventDefault();

		const main = document.querySelector('#report > main');
		const firstSection = main && [...main.children].find(child => child.offsetParent !== null);

		if (!firstSection) {
			return;
		}

		/* Buffer to clear the site's sticky header */
		const buffer = 13 * Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
		const top = firstSection.getBoundingClientRect().top + window.scrollY - buffer;

		window.scrollTo({ top, behavior: 'smooth' });
	});

	/* Display current section in table of contents */
	const sections = document.querySelectorAll('#report > main > section');
	const tocLinks = document.querySelectorAll('#report > aside .menu-list a');
	const tocItems = document.querySelectorAll('#report > aside .menu-list li');

	function updateToc() {
		const scrollPosition = window.scrollY;
		let currentSectionId = null;

		for (const section of sections) {
			const offsetTop = section.offsetTop - (window.innerHeight / 3);
			const offsetHeight = section.offsetHeight;
			if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
				currentSectionId = section.id.replace('section-', '');
			}
		}

		for (const item of tocItems) {
			item.classList.remove('is-selected');
		}

		if (currentSectionId) {
			for (const link of tocLinks) {
				if (link.getAttribute('href') === `#${currentSectionId}`) {
					link.parentNode.classList.add('is-selected');
				}
			}
		}
	}

	window.addEventListener('scroll', updateToc);
	updateToc();

	/* Close mobile menu when an option is selected */
	eachElement('.navbar-start .navbar-item', element => {
		element.addEventListener('click', () => {
			document.querySelector('.navbar-burger')?.classList.remove('is-active');
			document.querySelector('.navbar-menu')?.classList.remove('is-active');
			document.documentElement.classList.remove('has-menu-active');
		});
	});
});
